export const hasSharedItems = (target: any[], comparison: any[]): boolean => {
    return target.some(item => comparison.includes(item));
};
